import loadable from "@loadable/component";
import CreateIcon from "../../../Icons/Create";
import APIS from "../../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../../customHooks/usePatchHook";
import useGetHook from "../../../customHooks/useGetHook";

const EditServiceTypeComponent = loadable(
  () => import("../../../components/Settings/ServiceType/EditServiceType")
);
const EditServiceType = () => {
  const { id } = useParams()

  const { refetch } = useGetHook({
    queryKey: ["service-type"],
    url: `${APIS.SERVICE_TYPE}${id}/`,
    params: {},
  });



  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["service-type"],
    navigateURL: "/service-type",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.SERVICE_TYPE}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit Service Type</span>
      </div>
      <EditServiceTypeComponent
        isLoading={isPatchLoading}
        handleEdit={handleEdit}
        refetch={refetch}
      />
    </>
  );
};
export default EditServiceType;
